import { useContextSelector } from 'use-context-selector'

import { TurnListContext } from '../context/TurnListProvider'

export const useOutOfStoreList = () => {
  const moveWaitingListItemToOutOfStore = useContextSelector(
    TurnListContext,
    (turnList) => turnList.moveWaitingListItemToOutOfStore
  )

  return {
    moveWaitingListItemToOutOfStore,
  }
}
